import sliders_init from "./modules/sliders";
import togglePanels_init from "./modules/toggle-panels";
import mobileNav_init from "./modules/mobile-nav";

document.addEventListener('DOMContentLoaded', () => {
    sliders_init(),
    togglePanels_init(),
    mobileNav_init()
});


window.onscroll = function() { scrollFunction() };
var element = document.getElementById("topNav");

// console.log("query: ", document.documentElement.scrollTop);

// DC: when the user scrolls down 110px from the top of the document on tablet or above, resize the top navigation
function scrollFunction() {

    if (window.matchMedia("(min-width: 768px)").matches) {
      // DC: this scrollTop value MUST be greater than 60px (SVG logo image height (139px) - 80px), otherwise fluttering will occur
      if (document.documentElement.scrollTop > 110) {
        element.classList.add("fixed-nav");
      } 
      if (document.documentElement.scrollTop === 0) {
          element.classList.remove("fixed-nav");
      }

    }
}
